module.exports = __webpack_public_path__ + "static/img/sexual_violence_1.40cc76b2.png";